import { getAccountByAlternativeNames } from "static/constants";

import { useSelector } from "react-redux";

const useAuthorization = () => {
  const { currentUser } = useSelector((state) => state.auth);
  const { accounts = [] } = useSelector((state) => state.account);

  const checkHasAccountAccess = (account) => {
    const accountName = getAccountByAlternativeNames(account, accounts);

    const hasAccess = currentUser?.accounts?.includes(accountName) || false;

    return hasAccess;
  };

  const checkHasManufacturerAccess = (manufacturer) => {
    const hasAccess =
      currentUser?.manufacturer?.includes(manufacturer) || false;
    return hasAccess;
  };

  const getAccessibleAccountMappings = () => {
    return accounts?.map((account) => ({
      ...account,
      folder: account?.slug,
      hide: account?.display === false,
    }));
  };

  return {
    checkHasAccountAccess,
    checkHasManufacturerAccess,
    accessedAccountMappings: getAccessibleAccountMappings(),
  };
};

export default useAuthorization;
